import ApiClient from './ApiClient';

class DocalAPI extends ApiClient {
  constructor() {
    super('docal', { accountScoped: true });
  }

  getUrl(accountId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/docal/url`
    );
  }
  getDocumentsList(accountId) {
      return axios.get(
      `/api/v1/accounts/${accountId}/docal/documentList`
    );
  }
  getUnsignedDocumentsList(accountId, contactId) {
      return axios.get(
      `/api/v1/accounts/${accountId}/docal/unsignedDocumentList`,
      { params: { contactId } }
    );
  }
  getSigningLink(accountId, documentId, conversationId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/docal/signingLink`,
      { params: { documentId, conversationId } }
    );
  }
  getSigningLinkByEmail(accountId, documentId, email, inboxId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/docal/signingLink`,
      { params: { documentId, email, inbox_id: inboxId } }
    );
  }
  getSigningLinkByPhone(accountId, documentId, phoneNumber, inboxId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/docal/signingLink`,
      { params: { documentId, phone_number: phoneNumber, inbox_id: inboxId } }
    );
  }
}

export default new DocalAPI();
